export { createHttpRequest } from './httpRequest';
export { canUseEventBridge, bridgeSupports, getEventBridge } from './eventBridge';
export { startBatchWithReplica } from './startBatchWithReplica';
export { createFlushController } from './flushController';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum/~/@datadog/browser-core/esm/transport/index.js